import React from 'react';
import { getEnvVariable } from '../constants/whitelabelEnv';
import { domain } from '../constants/Branding';
import "./LandingPage.scss"
import LoginWrapper from '../components/LoginWrapper';
import exploreCasino from '../assets/stake/explore-casino-en.webp';
import exploreSports from '../assets/stake/explore-sports-en.webp';
import imgDuckHunters from '../assets/stake/duck-hunters.webp';
import imgSweetBonanza from '../assets/stake/sweet-bonanza.webp';
import imgPixelCafe from '../assets/stake/pixel-cafe.webp';
import imgOlympus from '../assets/stake/olympus.webp';
import imgHounds from '../assets/stake/hounds.webp';
import imgHercules from '../assets/stake/hercules.webp';
import imgDead from '../assets/stake/dead.webp';
import imgWaterfall from '../assets/stake/waterfall.webp';
import imgDuelAtDawn from '../assets/stake/duel-at-dawn.webp';
import imgCasinoCards from '../assets/stake/casino-poker-cards.jpg';
import imgSportsBalls from '../assets/stake/sports-balls.jpg';
import imgCasinoCardsSmall from '../assets/stake/casino-poker-cards-small.jpg';
import imgSportsBallsSmall from '../assets/stake/sports-balls-small.jpg';
import liveIceHockey from '../assets/stake/ice-hockey-en.webp';
import liveSoccer from '../assets/stake/soccer-en.webp';
import liveTennis from '../assets/stake/tennis-en.webp';
import liveMMA from '../assets/stake/mma-en.webp';
import liveRacing from '../assets/stake/racing-en.webp';
import liveVolleyball from '../assets/stake/volleyball-en.webp';
import promoRocket from '../assets/stake/promo-rocket.webp';
import promoNBA from '../assets/stake/promo-nba.webp';
import promoBasketball from '../assets/stake/promo-basketball.webp';
import promoFormula1 from '../assets/stake/formula-1-en.webp';
import promoCricket from '../assets/stake/cricket-en.webp';
import headerBg from '../assets/stake/header-bg.webp';
import LoginPage from '../components/Login';
import { connect } from 'react-redux';
import { RootState } from '../models/RootState';
import { SiteConfig } from '../models/SiteConfig';
import { FaChevronDown, FaFacebook, FaInstagram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import RegisterPage from '../components/RegisterPage';

const WhiteLabelLogo = getEnvVariable(domain, 'logo');
const BrandName = getEnvVariable(domain, 'BRAND_NAME');

const LandingPage: React.FC<{ referalCode?: string; siteConfig?: SiteConfig }> = ({ referalCode, siteConfig }) => {
  const [navCollapsed, setNavCollapsed] = React.useState(true);
  const contentPad = navCollapsed ? 'xl:pl-[84px]' : 'xl:pl-[260px]';
  const trendingGames = [
    { label: 'Duel at Dawn', image: imgDuelAtDawn, playing: 254 },
    { label: 'Sweet Bonanza 1000', image: imgSweetBonanza, playing: 496 },
    { label: 'Strength of Hercules', image: imgHercules, playing: 111 },
    { label: 'Joker Jam', image: imgWaterfall, playing: 63 },
    { label: 'Dead, Dead or Deader', image: imgDead, playing: 55 },
    { label: 'Pixel Cafe', image: imgPixelCafe, playing: 72 },
    { label: 'Gates of Olympus 1000', image: imgOlympus, playing: 538 },
    { label: 'Duck Hunters', image: imgDuckHunters, playing: 125 }
  ];
  const trendingSports = [
    { label: 'Soccer', image: liveSoccer },
    { label: 'Tennis', image: liveTennis },
    { label: 'Racing', image: liveRacing },
    { label: 'MMA', image: liveMMA },
    { label: 'Ice Hockey', image: liveIceHockey },
    { label: 'VolleyBall', image: liveVolleyball },
    { label: 'Formula 1', image: promoFormula1 },
    { label: 'Cricket', image: promoCricket },
    { label: 'Basketball', image: promoBasketball },
  ];
  const gamesRef = React.useRef<HTMLDivElement>(null);
  const sportsRef = React.useRef<HTMLDivElement>(null);
  const whatsappMenuRef = React.useRef<HTMLDivElement>(null);
  const [betsTab, setBetsTab] = React.useState<'casino' | 'sports' | 'race'>('casino');
  const [showWhatsappMenu, setShowWhatsappMenu] = React.useState(false);

  // Close WhatsApp menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (whatsappMenuRef.current && !whatsappMenuRef.current.contains(event.target as Node)) {
        setShowWhatsappMenu(false);
      }
    };

    if (showWhatsappMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showWhatsappMenu]);
  const betRows = [
    { game: 'Crash', user: 'Hidden', time: '3:30 PM', amount: '0.60217566', currency: 'Ξ', multiplier: '0.00×', payout: '-0.60217566', payoutPositive: false },
    { game: 'Baccarat A', user: 'Hidden', time: '3:30 PM', amount: '2754.108578', currency: '₮', multiplier: '7.41×', payout: '1482.00', payoutPositive: true },
    { game: 'Lightning Storm', user: 'Hidden', time: '3:30 PM', amount: '199.96', currency: '₮', multiplier: '3.00×', payout: '1799.82', payoutPositive: true },
    { game: 'Strength of Hercules', user: 'Hidden', time: '3:30 PM', amount: '1689.83', currency: '₮', multiplier: '0.00×', payout: '-1689.83', payoutPositive: false },
    { game: 'Crazy Time', user: 'Hidden', time: '3:29 PM', amount: '624000', currency: '₪', multiplier: '0.00×', payout: '624,000.00', payoutPositive: true },
  ];

  const scrollRow = (ref: React.RefObject<HTMLDivElement>, direction: 'left' | 'right') => {
    const el = ref.current;
    if (!el) return;
    const firstCard = el.querySelector('[data-card]') as HTMLElement | null;
    const gap = 16; // px, matches gap-4
    const cardsPerStep = 3; // scroll by 3 cards
    const cardWidth = firstCard ? firstCard.offsetWidth : el.clientWidth / cardsPerStep;
    const amount = (cardWidth + gap) * cardsPerStep * (direction === 'left' ? -1 : 1);
    el.scrollBy({ left: amount, behavior: 'smooth' });
  };

  const [showLogin, setShowLogin] = React.useState(false);
  const [showRegister, setShowRegister] = React.useState(false);
  const openLogin = (e?: React.MouseEvent) => {
    if (e) e.preventDefault();
    setShowLogin(true);
  };
  const closeLogin = () => setShowLogin(false);
  const openRegister = (e?: React.MouseEvent) => {
    if (e) e.preventDefault();
    setShowRegister(true);
  };
  const closeRegister = () => setShowRegister(false);

  return (
    <>
      <div className="min-h-screen bg-[#0E1922] text-white landing-page">
        <header className="w-full border-b border-white/10 sticky top-0 z-50 backdrop-blur supports-[backdrop-filter]:bg-[#0F1C27]/75">
          <div className="max-w-[1400px] mx-auto px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-[92px] h-8 rounded bg-[#132A37] flex items-center justify-center xl:ml-12">
                <img src={WhiteLabelLogo} alt="Logo" className="w-full h-full object-contain" />
              </div>
              {/* <span className="font-semibold">Stake</span> */}
            </div>

            <div className="flex items-center gap-2">
              <button onClick={openLogin} className="px-4 py-2 text-sm bg-transparent hover:bg-white/10 rounded">Login</button>
              <button onClick={openRegister} className="px-4 py-2 text-sm bg-[#0E8BF0] hover:bg-[#0c79ce] rounded text-white">Register</button>
            </div>
          </div>
        </header>
        <main className="relative">
          <aside className={`hidden xl:flex fixed left-0 top-[0px] bottom-0 ${navCollapsed ? 'w-[72px]' : 'w-[240px]'} z-50 border-r border-white/5 bg-[#0F212E]/80 transition-[width] duration-300`}>
            <div className="flex flex-col py-4 w-full">
              {/* Hamburger Menu Icon */}
              <div className="px-3 flex items-center justify-center mb-6">
                <button aria-label="Toggle sidebar" className="w-8 h-8 rounded hover:bg-white/5 flex items-center justify-center text-white/70">
                  <svg viewBox="0 0 24 24" className="w-5 h-5">
                    <path fill="currentColor" d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z" />
                  </svg>
                </button>
              </div>

              {/* Casino Card */}
              <div className="px-3 mb-4">
                <div className="rounded-lg bg-[#1A2C38] cursor-pointer hover:bg-[#223a49] transition-colors h-12 w-12" onClick={openLogin}>
                  <img src={imgCasinoCardsSmall} alt="Casino" className="w-full h-full object-cover rounded-lg" />
                </div>
              </div>

              {/* Sports Card */}
              <div className="px-3 mb-2">
                <div className="rounded-lg bg-[#1A2C38] cursor-pointer hover:bg-[#223a49] transition-colors h-12 w-12" onClick={openLogin}>
                  <img src={imgSportsBallsSmall} alt="Sports" className="w-full h-full object-cover rounded-lg" />
                </div>
              </div>

              {/* Navigation Items Container */}
              <div className="px-3 mb-4">
                <div className="rounded-lg bg-[#1A2C38] p-2 space-y-1">
                  {[
                    {
                      label: 'Promotions', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M28.651 60.5H11.883c-1.85 0-3.347-1.5-3.347-3.348V37.036c-1.85 0-3.348-1.5-3.348-3.348v-6.722c0-1.85 1.5-3.348 3.348-3.348h20.116V60.5Zm26.813-36.884H35.347V60.5h16.768c1.85 0 3.349-1.5 3.349-3.348V37.036c1.85 0 3.348-1.5 3.348-3.348v-6.722c0-1.85-1.5-3.348-3.348-3.348v-.002ZM45.416 3.5C38.005 3.5 32 9.508 32 16.918h13.418c1.85 0 3.349-1.5 3.349-3.348V6.848c0-1.85-1.5-3.348-3.349-3.348Zm-26.836 0c-1.85 0-3.348 1.5-3.348 3.348v6.722c0 1.85 1.5 3.348 3.348 3.348H32C32 9.506 25.99 3.5 18.58 3.5Z">
                        </path>
                      </svg>), chevron: true
                    },
                    {
                      label: 'Originals', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M55.543 19.096a8.353 8.353 0 0 0-8.296 7.437l-.004.038-6.464 1.73a8.172 8.172 0 0 0-3.56-2.641l-.057-.018v-7.05c3.127-1.262 5.293-4.272 5.293-7.79 0-4.628-3.75-8.38-8.38-8.38a8.378 8.378 0 0 0-8.378 8.38 8.383 8.383 0 0 0 5.237 7.771l.055.02v6.837a7.744 7.744 0 0 0-1.959 1.103l.018-.014-12.29-6.703a6.611 6.611 0 0 0 0-.736v.018c0-4.629-3.75-8.38-8.379-8.38A8.378 8.378 0 0 0 0 19.098a8.378 8.378 0 0 0 8.38 8.379 8.183 8.183 0 0 0 5.538-2.16l-.006.005 11.916 6.57a7.87 7.87 0 0 0 .002 1.415l-.002-.03a8.528 8.528 0 0 0 .66 3.276l-.021-.056-9.311 9.043a8.107 8.107 0 0 0-3.43-.772h-.002l-.16-.002a8.405 8.405 0 0 0-8.405 8.406 8.405 8.405 0 0 0 8.405 8.405 8.405 8.405 0 0 0 8.406-8.405 7.947 7.947 0 0 0-.63-3.35l.02.052 9.31-9.044a8.057 8.057 0 0 0 3.414.744h.02a7.938 7.938 0 0 0 2.318-.36l-.056.015 2.66 4.124a8.25 8.25 0 0 0-1.49 4.734v.026a8.405 8.405 0 0 0 8.405 8.405 8.405 8.405 0 0 0 8.405-8.405 8.405 8.405 0 0 0-8.405-8.405 7.84 7.84 0 0 0-1.836.223l.054-.012-2.927-4.443a7.84 7.84 0 0 0 1.114-3.262l.003-.035 6.49-1.73A8.378 8.378 0 0 0 64 27.527a8.377 8.377 0 0 0-8.378-8.38h-.082.004v-.051Z">
                        </path>
                      </svg>)
                    },
                    {
                      label: 'Leaderboards', icon: (<svg fill="currentColor" viewBox="0 0 96 96" className="svg-icon ">
                        <title></title>
                        <path d="M64.688 54.312c37.121-4.57 30.353-38.63 30.353-38.63H78.354c.628-4.697.991-10.138 1.005-15.665V0H16.64c.014 5.54.377 10.982 1.073 16.32l-.068-.641H.958S-5.807 49.69 31.31 54.309c2.62 3.87 5.51 7.244 8.743 10.254l.034.031c-.411 5.579-2.65 21.624-15.59 21.624h-7.861V96h62.719v-9.782l-10.88-.367C58.192 83.52 56.272 69.67 55.905 64.594a59.158 59.158 0 0 0 8.647-10.08l.13-.205.007.003ZM75.43 30.267l2.194-5.44h8.503c-.33 4.638-1.995 8.831-4.611 12.26l.04-.055a22.158 22.158 0 0 1-10.542 6.682l-.158.038c1.735-3.789 3.302-8.283 4.457-12.94l.117-.548v.003Zm-60.984 6.765a22.653 22.653 0 0 1-4.567-12.134l-.003-.072h8.41l2.287 5.441c1.395 5.322 3.051 9.882 5.064 14.246l-.22-.531c-4.409-1.235-8.143-3.665-10.947-6.92l-.024-.027v-.003Zm40.78 3.977-6.402-3.11a1.712 1.712 0 0 0-.823-.205c-.301 0-.586.075-.833.212l.01-.003-6.4 3.11a1.604 1.604 0 0 1-2.243-1.656v.006l1.005-7.176a1.547 1.547 0 0 0-.411-1.282l-4.846-5.256a1.56 1.56 0 0 1 .813-2.606h.01l7.176-1.326c.498-.055.916-.35 1.139-.768l.003-.007 3.429-6.401a1.555 1.555 0 0 1 2.74-.007l.003.007 3.428 6.4c.216.416.617.71 1.09.776h.007l7.176 1.326a1.555 1.555 0 0 1 .823 2.606l-5.03 5.256a1.548 1.548 0 0 0-.425 1.07c0 .075.007.147.014.22v-.008l1.005 7.176a1.6 1.6 0 0 1-2.475 1.646l.006.004.01-.004Z">
                        </path>
                      </svg>)
                    },
                    {
                      label: 'History', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M16 2.666v48c0 1.6-1.066 2.666-2.666 2.666-1.6 0-2.666-1.066-2.666-2.666V8h-8v45.334c0 4.534 3.466 8 8 8h50.666V2.668H16v-.002ZM34.666 48H24V26.666h10.666V48Zm18.668 0H40v-8h13.334v8Zm0-13.334H40v-8h13.334v8Zm0-13.332H24v-8h29.334v8Z">
                        </path>
                      </svg>)
                    },
                    {
                      label: 'Live Chat', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M32 1.916c-.288-.01-.628-.016-.97-.016C14.254 1.9.586 15.206.002 31.84L0 31.894A28.655 28.655 0 0 0 7.476 51.15l-.02-.024c-.688 4.028-1.89 7.636-3.552 10.974l.102-.228c4.634-.396 8.878-1.73 12.654-3.81l-.164.082c4.474 2.35 9.774 3.728 15.398 3.728h.112H32c.3.01.654.016 1.008.016 16.768 0 30.428-13.31 30.99-29.942l.002-.052C63.414 15.206 49.746 1.902 32.97 1.902c-.342 0-.68.006-1.018.016l.05-.002H32ZM16.138 37.604a5.948 5.948 0 1 1 0-11.896 5.948 5.948 0 0 1 0 11.896Zm15.862 0a5.948 5.948 0 1 1 0-11.896 5.948 5.948 0 0 1 0 11.896Zm15.862 0a5.948 5.948 0 1 1 0-11.896 5.948 5.948 0 0 1 0 11.896Z">
                        </path>
                      </svg>)
                    },
                  ].map((item, idx) => (
                    <div key={idx} className={` rounded hover:bg-white/5 flex items-center justify-between text-sm transition-colors cursor-pointer`} onClick={openLogin}>
                      <div className="flex pt-3 items-center gap-3 text-gray-200" title={item.label}>
                        <div className="w-6 h-6 rounded flex items-center justify-center text-white/80">{item.icon}</div>
                        {!navCollapsed && <span className="truncate">{item.label}</span>}
                      </div>
                      {!navCollapsed && item.chevron ? <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/40"><path fill="currentColor" d="M9 6l6 6-6 6" /></svg> : null}
                    </div>
                  ))}
                </div>
              </div>

              {/* Bottom Section Container */}
              <div className="px-3">
                <div className="rounded-lg bg-[#1A2C38] p-2 space-y-1">
                  {[
                    {
                      label: 'Affiliates', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.081 3.816 0 24.548l4.958 3.129 13.08-20.733-4.957-3.128Zm11.17 4.493h15.987l17.587 25.314-27.446-17.586-5.596 8.793c-1.332 2.398-4.263 2.931-6.395 1.599-1.599-1.066-2.398-3.198-2.132-5.063 0-.533.267-1.066.533-1.599L24.25 8.31Zm-3.465 22.65c-1.6 0-3.198-.533-4.53-1.333-1.332-.799-2.398-1.865-2.931-3.197L9.86 32.025c.266 0 6.661.266 8.526 5.062 1.6 0 2.932 0 4.53 1.066 1.333.8 2.665 2.398 3.198 3.997 1.599 0 3.198.533 4.53 1.333 4.263 2.398 5.596 7.994 2.931 11.99l-.533 1.066 4.796 2.931c2.132 1.333 5.063.8 6.396-1.598a4.861 4.861 0 0 0-.8-5.863l2.132 1.333c2.132 1.332 5.063.533 6.395-1.6 1.332-2.13.533-5.062-1.599-6.394l1.333.8c2.131 1.331 5.062.799 6.395-1.6 1.332-2.131.8-5.062-1.6-6.395L30.646 22.165l-2.931 4.797c-1.066 2.398-3.997 3.997-6.928 3.997Zm8.26 15.721c-2.422-1.453-5.283-.265-6.385.964 1.214-1.865.387-4.53-1.61-6.026-.799-.534-1.598-.8-2.664-.8-1.573 0-3.145.774-3.957 2.067 1.281-2.126.738-5.014-1.372-6.597-.8-.533-1.599-.8-2.665-.8-1.599 0-3.197.8-3.997 2.133l-.8 1.065-2.131 3.464c-1.332 2.132-.8 5.063 1.599 6.662.8.533 1.599.8 2.664.8 1.399 0 2.797-.612 3.66-1.657-.115.218-.195.445-.195.59-1.066 2.665 0 5.33 2.398 6.396 2.197.976 4.841.163 6.089-1.824-.92 2.059-.284 4.628 1.905 6.087.799.533 1.598.8 2.664.8 1.6 0 3.198-.8 3.997-2.132l2.665-4.53c1.332-2.398.266-5.33-1.865-6.662ZM45.819 7.006l4.958-3.128L64 24.835l-4.958 3.128L45.82 7.006Z">
                        </path>
                      </svg>), chevron: true
                    },
                    {
                      label: 'Security', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M32 0 5.654 11.306C5.654 52.692 32 64 32 64s26.346-11.306 26.346-52.694L32 0Zm3.546 33.014v13.2h-7.12v-13.2c-3.174-1.41-5.346-4.532-5.346-8.164a8.907 8.907 0 1 1 12.522 8.142l-.056.022Z">
                        </path>
                      </svg>)
                    },
                    {
                      label: 'Support', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M32-.001h-.084C17.056-.001 5.01 12.045 5.01 26.905c0 .178.002.356.006.534v-.026 22.374h17.386V30.613h-8.186v-3.2a17.59 17.59 0 0 1-.01-.588c0-9.734 7.892-17.626 17.626-17.626h.178H32h.17c9.734 0 17.626 7.892 17.626 17.626 0 .206-.004.412-.01.618v-.03 3.2H41.6v19.174h7.546c-1.734 4.134-7.28 5.014-17.146 5.014v9.2c8.774 0 26.986 0 26.986-17.386v-19.2c.004-.15.004-.328.004-.506C58.99 12.049 46.944.003 32.084.003h-.09L32-.001Z">
                        </path>
                      </svg>)
                    },
                    {
                      label: 'Language', icon: (<svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                        <title></title>
                        <path d="M32 0C14.336 0 0 14.336 0 32s14.336 32 32 32 32-14.336 32-32S49.664 0 32 0Zm25.408 28.8H46.336c-.352-8.096-2.08-15.328-4.672-20.512 8.416 3.424 14.592 11.2 15.744 20.512ZM6.592 35.2h11.072c.352 8.096 2.08 15.328 4.672 20.512A25.655 25.655 0 0 1 6.592 35.2Zm11.072-6.4H6.592c1.152-9.312 7.328-17.088 15.744-20.512-2.592 5.184-4.288 12.416-4.672 20.512ZM36.352 52c-1.088 2.4-2.208 3.968-3.136 4.832-.448.416-.768.608-.96.704-.16.064-.224.064-.256.064s-.096 0-.256-.064c-.192-.096-.512-.288-.96-.704-.928-.864-2.048-2.432-3.136-4.832-1.856-4.16-3.232-10.016-3.584-16.8h15.84c-.32 6.784-1.696 12.64-3.552 16.8ZM24.064 28.8c.32-6.784 1.696-12.64 3.584-16.8 1.088-2.4 2.208-3.968 3.136-4.832.448-.416.768-.608.96-.704.16-.064.224-.064.256-.064s.096 0 .256.064c.192.096.512.288.96.704.928.864 2.048 2.432 3.136 4.832 1.856 4.16 3.232 10.016 3.584 16.8H24.064Zm17.6 26.912c2.56-5.184 4.288-12.416 4.672-20.512h11.072c-1.152 9.312-7.328 17.088-15.744 20.512Z">
                        </path>
                      </svg>), chevron: true
                    },
                  ].map((item, idx) => (
                    <div key={idx} className={`rounded hover:bg-white/5 flex items-center justify-between text-sm transition-colors cursor-pointer`} onClick={openLogin}>
                      <div className="flex pt-2 items-center gap-3 text-gray-200" title={item.label}>
                        <div className="w-6 h-6 rounded flex items-center justify-center text-white/80">{item.icon}</div>
                        {!navCollapsed && <span className="truncate">{item.label}</span>}
                      </div>
                      {!navCollapsed && item.chevron ? <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/40"><path fill="currentColor" d="M9 6l6 6-6 6" /></svg> : null}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </aside>

          <div className="w-full bg-[#0b1a23]/70 border-b border-white/5">
            {/* <div className={`max-w-[1400px] mx-auto px-4 py-2 text-xs text-gray-300 flex items-center gap-2 ${contentPad}`}> */}
            {/*   <span className="px-2 py-0.5 rounded bg-[#0e2430] text-[#00AEEF]">Promo</span> */}
            {/*   <span>Welcome bonus visual only — no functionality</span> */}
            {/* </div> */}
          </div>
          <section className={`relative max-w-[1400px] mx-auto px-4 py-10 ${contentPad}`} style={{ backgroundImage: `url(${headerBg})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '0.75rem' }}>
            <div className="absolute inset-0 bg-[#0E1922]/60 rounded-xl" />
            <div className="relative grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-6 items-stretch">
              <div>
                <h1 className="text-[2rem] md:text-[2.5rem] lg:text-[2.75rem] font-bold leading-[1.15] tracking-tight">World's Largest Online Casino and Sportsbook</h1>
                <div className="mt-5">
                  <button onClick={openLogin} className="w-full sm:w-auto px-5 py-3 bg-[#0E8BF0] hover:bg-[#0c79ce] rounded text-white text-sm font-semibold">Register</button>
                </div>
                <div className="mt-6 flex items-center gap-3 text-sm text-gray-300">
                  <div className="h-px flex-1 bg-white/10" />
                  <span>Or sign up with</span>
                  <div className="h-px flex-1 bg-white/10" />
                </div>
                <div className="mt-3 flex gap-2">
                  {/* Facebook */}
                  <div className="w-10 h-10 rounded-md bg-[#1A2C38] hover:bg-[#223a49] border border-white/10 flex items-center justify-center">
                    {/* <svg viewBox="0 0 24 24" className="w-5 h-5 text-white"><path fill="currentColor" d="M13 3h4V0h-4a5 5 0 0 0-5 5v3H5v4h3v12h4V12h3.1l.9-4H12V5a1 1 0 0 1 1-1Z"/></svg> */}
                    <svg fill="none" viewBox="0 0 96 96" className="svg-icon " style={{ width: "1.25rem", height: "1.25rem" }}>
                      <title></title>
                      <path d="M95.94 47.97C95.94 21.467 74.473 0 47.97 0S0 21.467 0 47.97c0 22.486 15.47 41.374 36.397 46.59v-31.9h-9.894V47.97h9.894v-6.296c0-16.31 7.376-23.925 23.446-23.925 3.058 0 8.274.6 10.433 1.2v13.31c-1.14-.12-3.118-.18-5.516-.18-7.856 0-10.914 3-10.914 10.734v5.157h15.65l-2.698 14.69H53.846v32.98C77.591 92.762 96 72.555 96 48.03l-.06-.06Z" fill="#0866FF"></path>
                      <path d="m66.738 62.66 2.699-14.69h-15.65v-5.157c0-7.735 3.057-10.733 10.913-10.733 2.458 0 4.437 0 5.516.18V18.948c-2.158-.6-7.375-1.2-10.433-1.2-16.01 0-23.446 7.556-23.446 23.926v6.296h-9.894v14.69h9.894v31.9c3.718.9 7.615 1.44 11.573 1.44a46.6 46.6 0 0 0 5.816-.36V62.66h13.012Z" fill="#fff"></path>
                    </svg>
                  </div>
                  {/* Google */}
                  <div className="w-10 h-10 rounded-md bg-[#1A2C38] hover:bg-[#223a49] border border-white/10 flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="#EA4335" d="M12 10.2v3.9h5.4c-.24 1.26-1.62 3.7-5.4 3.7-3.25 0-5.9-2.68-5.9-6s2.65-6 5.9-6c1.85 0 3.09.78 3.8 1.46l2.58-2.5C16.77 3.2 14.6 2.3 12 2.3 6.97 2.3 2.9 6.37 2.9 11.4S6.97 20.5 12 20.5c6.94 0 9.6-4.86 9.6-7.3 0-.49-.05-.85-.12-1.22H12Z" /></svg>
                  </div>
                  {/* Telegram */}
                  <div className="w-10 h-10 rounded-md bg-[#1A2C38] hover:bg-[#223a49] border border-white/10 flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-5 h-5 text-white"><path fill="currentColor" d="M9.04 15.9 8.9 20c.4 0 .58-.17.79-.38l1.9-1.82 3.93 2.88c.72.4 1.23.19 1.41-.66l2.56-12.02h.01c.23-1.08-.39-1.5-1.09-1.24L3.2 9.4c-1.06.41-1.04 1-.18 1.26l4.79 1.49 11.13-6.94c.52-.32 1-.15.61.2L9.04 15.9Z" /></svg>
                  </div>
                  {/* Twitch */}
                  <div className="w-10 h-10 rounded-md bg-[#1A2C38] hover:bg-[#223a49] border border-white/10 flex items-center justify-center">
                    {/* <svg viewBox="0 0 24 24" className="w-5 h-5 text-white"><path fill="currentColor" d="M4 3 3 6v13h5v2h2l2-2h4l5-5V3H4Zm16 9-3 3h-5l-2 2v-2H7V5h13v7Zm-3-6h-2v5h2V6Zm-4 0h-2v5h2V6Z" /></svg> */}
                    <svg fill="none" viewBox="0 0 96 96" className="svg-icon " style={{ width: "1.25rem", height: "1.25rem" }}>
                      <title></title>
                      <path d="M82.378 44.593 68.69 58.281H55.002L42.987 70.297V58.28H27.565V6.875h54.813v37.718Z" fill="#fff"></path>
                      <path d="M24.156 0 7 17.156v61.688h20.563V96l17.156-17.156h13.688L89.25 48V0H24.156Zm58.222 44.593L68.69 58.281H55.002L42.987 70.297V58.28H27.565V6.875h54.813v37.718Z" fill="#9146FF"></path>
                      <path d="M72.156 18.89h-6.875v20.563h6.875V18.89Zm-18.89 0H46.39v20.563h6.875V18.89Z" fill="#9146FF"></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 md:my-[15px]">
                {[
                  { title: 'Casino', image: exploreCasino },
                  { title: 'Sports', image: promoNBA }
                ].map((card) => (
                  <div key={card.title} className="rounded-xl overflow-hidden border border-white/5 bg-[#122939] transition-transform duration-200 hover:-translate-y-1" onClick={openLogin}>
                    <div className="h-28 sm:h-32 md:h-48 relative">
                      <img src={card.image} alt={card.title} className="w-full h-full object-cover" />
                      <div className="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent" />
                    </div>
                    <div className="px-3 py-2 flex items-center justify-between text-sm">
                      <div className="flex items-center gap-2">
                        <div>
                          {
                            card.title === 'Casino' ? (
                              <svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                                <title></title>
                                <path d="M12.265 47.726.21 14.603a3.574 3.574 0 0 1 2.108-4.553l.024-.007 19.282-7.015a3.55 3.55 0 0 1 4.553 2.082l.008.024.694 1.92L12.69 46.073a8.9 8.9 0 0 0-.418 1.598l-.008.056ZM63.79 15.511 48.002 58.93a3.529 3.529 0 0 1-4.558 2.1l.024.009-21.948-8.001a3.58 3.58 0 0 1-2.124-4.585l-.008.024 15.787-43.39a3.555 3.555 0 0 1 4.559-2.126l-.024-.008 21.948 8a3.58 3.58 0 0 1 2.124 4.585l.008-.024v-.002ZM50.457 32.685l-1.386-3.254a1.789 1.789 0 0 0-2.333-.956l.012-.004-2.666 1.174a1.787 1.787 0 0 1-2.316-.948l-.004-.012-1.146-2.667a1.764 1.764 0 0 0-2.332-.93l.012-.004-3.28 1.386a1.738 1.738 0 0 0-.929 2.33l-.004-.01 3.92 9.255a1.816 1.816 0 0 0 2.359.928l-.012.005 9.227-3.947a1.737 1.737 0 0 0 .794-2.356l.004.01h.08Z">
                                </path>
                              </svg>
                            ) : (
                              <svg fill="currentColor" viewBox="0 0 96 96" className="svg-icon ">
                                <title></title>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.287 13.917c16.599 6.854 30.869 15.965 43.231 27.143l-.001.002.126.11-.125-.112C64.262 31 65.501 17.31 60.63 1.865 56.773.739 52.34.092 47.758.092c-13.046 0-24.87 5.249-33.47 13.748v.077Zm79.997 46.514a46.803 46.803 0 0 1-7.907 15.996v-.003c-2.275-3.87-4.709-7.622-7.185-11.295l-.137.08c4.463-2.823 9.63-4.63 15.307-5.11l-.078.332ZM80.986 82.734c-4.75 4.553-10.46 8.116-17.124 10.458h-.003l.006-.108a38.977 38.977 0 0 1 9.137-22.842l-.281-.41c2.838 3.924 5.478 8.005 8.265 12.902Zm0 0 .016-.014-.015.015ZM12.017 64.772a83.99 83.99 0 0 0 9.697.599h.003l-.117-.006c.832.039 1.674.06 2.518.06 12.98 0 24.848-4.766 33.883-12.589a132.455 132.455 0 0 1 9.859 11.137 47.738 47.738 0 0 0-11.975 31.216l.284-.042c-2.68.49-5.44.751-8.269.76-21.022-.012-38.88-13.566-45.416-32.75 3.102.685 6.287 1.224 9.931 1.654l-.398-.039Zm-9.533-1.614c-.226-.05-.45-.1-.675-.152l.667.129.008.023Zm65.376.815.045-.051-.045.05ZM58 52.836l-.009-.009.01.01Zm-5.59-5.706A140.354 140.354 0 0 0 9.776 20.677l-.952-.332C3.305 28.021 0 37.61 0 47.97v.038c.018 2.3.192 4.539.512 6.733l-.033-.266c3.542.97 7.889 1.823 12.325 2.386l.488.05c16.526 1.797 30.138-1.637 39.12-9.78Zm21.58 11.182a149.73 149.73 0 0 0-10.601-11.7c7.864-10.897 10.059-25.19 6.466-41.155l.267.126C85.46 13.537 95.953 29.542 96 48.007c0 .604-.048 1.247-.097 1.904-.051.688-.104 1.393-.104 2.087h-.042c-8.002.159-15.445 2.596-21.552 6.586l-.215-.272Zm-10.601-11.7-.003-.003.003.003Z">
                                </path>
                              </svg>
                            )
                          }
                        </div>
                        <span>{card.title}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* <div className="mt-6 flex gap-2 overflow-x-auto no-scrollbar">
              {['Originals','Slots','Live Casino','Game Shows','Table Games','New','Top'].map((label) => (
                <div key={label} className="px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 text-sm text-gray-200 whitespace-nowrap cursor-pointer border border-white/5">
                  {label}
                </div>
              ))}
            </div> */}
            {/* <div className="mt-4 flex items-center gap-3 bg-[#0b1a23] border border-white/5 rounded-lg p-2">
              <div className="px-3 py-1.5 rounded-md bg-white/5 text-sm">Casino</div>
              <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/60"><path fill="currentColor" d="M7 10l5 5 5-5H7z" /></svg>
              <div className="flex-1">
                <input className="w-full bg-transparent outline-none text-sm placeholder:text-gray-400" placeholder="Search your game" />
              </div>
            </div> */}
          </section>
          {/* Trending Games */}
          <section className={`max-w-[1400px] mt-[1rem] mx-auto px-4 pb-16 ${contentPad}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                  <title></title>
                  <path d="M12.265 47.726.21 14.603a3.574 3.574 0 0 1 2.108-4.553l.024-.007 19.282-7.015a3.55 3.55 0 0 1 4.553 2.082l.008.024.694 1.92L12.69 46.073a8.9 8.9 0 0 0-.418 1.598l-.008.056ZM63.79 15.511 48.002 58.93a3.529 3.529 0 0 1-4.558 2.1l.024.009-21.948-8.001a3.58 3.58 0 0 1-2.124-4.585l-.008.024 15.787-43.39a3.555 3.555 0 0 1 4.559-2.126l-.024-.008 21.948 8a3.58 3.58 0 0 1 2.124 4.585l.008-.024v-.002ZM50.457 32.685l-1.386-3.254a1.789 1.789 0 0 0-2.333-.956l.012-.004-2.666 1.174a1.787 1.787 0 0 1-2.316-.948l-.004-.012-1.146-2.667a1.764 1.764 0 0 0-2.332-.93l.012-.004-3.28 1.386a1.738 1.738 0 0 0-.929 2.33l-.004-.01 3.92 9.255a1.816 1.816 0 0 0 2.359.928l-.012.005 9.227-3.947a1.737 1.737 0 0 0 .794-2.356l.004.01h.08Z">
                  </path>
                </svg>
                <h2 className="text-xl font-semibold">Trending Games</h2>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => scrollRow(gamesRef, 'left')} className="w-8 h-8 rounded bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center" aria-label="Scroll left">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/80"><path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" /></svg>
                </button>
                <button onClick={() => scrollRow(gamesRef, 'right')} className="w-8 h-8 rounded bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center" aria-label="Scroll right">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/80"><path fill="currentColor" d="M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z" /></svg>
                </button>
              </div>
            </div>
            <div ref={gamesRef} className="overflow-x-auto no-scrollbar">
              <div className="flex gap-4">
                {trendingGames.map((game, idx) => (
                  <div key={idx} data-card className="group shrink-0 w-[calc((100%_-_2rem)/3)] sm:w-[160px] md:w-[165px] lg:w-[170px] xl:w-[170px] cursor-pointer" onClick={openLogin}>
                    <div className="transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg rounded-xl">
                      <div className="relative aspect-[2/3] md:aspect-[2/3] lg:aspect-[4/5] rounded-lg overflow-hidden border border-white/5">
                        <img src={game.image} alt={game.label} className="w-full h-full object-cover" />
                        <div className="absolute top-[16px] left-[-1px]">
                          <div className="shadow-sm shadow-grey-600 rounded-tr rounded-br flex justify-center p-2 bg-[#2f4553] w-[26px] text-white font-bold leading-[120%]">
                            {idx + 1}</div>
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition flex items-end p-2">
                          <button onClick={openLogin} className="w-full py-2 text-xs rounded bg:white/15 bg-white/15 hover:bg-white/25 text-white border border-white/10">Play</button>
                        </div>
                      </div>
                      <div className="mt-2 flex items-center gap-2 text-xs text-gray-300">
                        <span className="w-2 h-2 rounded-full bg-[#00c853]"></span>
                        {game.playing?.toLocaleString()} playing
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/* Trending Sports */}
          <section className={`max-w-[1400px] mx-auto px-4 pb-16 ${contentPad}`}>
            <div className="flex items-center justify-between mb-4">
              <div className='flex items-center gap-2'>
                <svg fill="currentColor" viewBox="0 0 96 96" className="svg-icon ">
                  <title></title>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.287 13.917c16.599 6.854 30.869 15.965 43.231 27.143l-.001.002.126.11-.125-.112C64.262 31 65.501 17.31 60.63 1.865 56.773.739 52.34.092 47.758.092c-13.046 0-24.87 5.249-33.47 13.748v.077Zm79.997 46.514a46.803 46.803 0 0 1-7.907 15.996v-.003c-2.275-3.87-4.709-7.622-7.185-11.295l-.137.08c4.463-2.823 9.63-4.63 15.307-5.11l-.078.332ZM80.986 82.734c-4.75 4.553-10.46 8.116-17.124 10.458h-.003l.006-.108a38.977 38.977 0 0 1 9.137-22.842l-.281-.41c2.838 3.924 5.478 8.005 8.265 12.902Zm0 0 .016-.014-.015.015ZM12.017 64.772a83.99 83.99 0 0 0 9.697.599h.003l-.117-.006c.832.039 1.674.06 2.518.06 12.98 0 24.848-4.766 33.883-12.589a132.455 132.455 0 0 1 9.859 11.137 47.738 47.738 0 0 0-11.975 31.216l.284-.042c-2.68.49-5.44.751-8.269.76-21.022-.012-38.88-13.566-45.416-32.75 3.102.685 6.287 1.224 9.931 1.654l-.398-.039Zm-9.533-1.614c-.226-.05-.45-.1-.675-.152l.667.129.008.023Zm65.376.815.045-.051-.045.05ZM58 52.836l-.009-.009.01.01Zm-5.59-5.706A140.354 140.354 0 0 0 9.776 20.677l-.952-.332C3.305 28.021 0 37.61 0 47.97v.038c.018 2.3.192 4.539.512 6.733l-.033-.266c3.542.97 7.889 1.823 12.325 2.386l.488.05c16.526 1.797 30.138-1.637 39.12-9.78Zm21.58 11.182a149.73 149.73 0 0 0-10.601-11.7c7.864-10.897 10.059-25.19 6.466-41.155l.267.126C85.46 13.537 95.953 29.542 96 48.007c0 .604-.048 1.247-.097 1.904-.051.688-.104 1.393-.104 2.087h-.042c-8.002.159-15.445 2.596-21.552 6.586l-.215-.272Zm-10.601-11.7-.003-.003.003.003Z">
                  </path>
                </svg>
                <h2 className="text-xl font-semibold">Trending Sports</h2>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => scrollRow(sportsRef, 'left')} className="w-8 h-8 rounded bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center" aria-label="Scroll left">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/80"><path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" /></svg>
                </button>
                <button onClick={() => scrollRow(sportsRef, 'right')} className="w-8 h-8 rounded bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center" aria-label="Scroll right">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 text-white/80"><path fill="currentColor" d="M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z" /></svg>
                </button>
              </div>
            </div>
            <div ref={sportsRef} className="overflow-x-auto no-scrollbar">
              <div className="flex gap-4">
                {trendingSports.map((sport, idx) => (
                  <div key={idx} data-card className="group shrink-0 w-[calc((100%_-_2rem)/3)] sm:w-[160px] md:w-[165px] lg:w-[170px] xl:w-[170px] cursor-pointer" onClick={openLogin}>
                    <div className="transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg rounded-xl">
                      <div className="relative aspect-[2/3] md:aspect-[2/3] lg:aspect-[4/5] rounded-lg overflow-hidden border border-white/5">
                        <img src={sport.image} alt={sport.label} className="w-full h-full object-cover" />
                        <div className="absolute top-[16px] left-[-1px]">
                          <div className="shadow-sm shadow-grey-600 rounded-tr rounded-br flex justify-center p-2 bg-[#2f4553] w-[26px] text-white font-bold leading-[120%]">
                            {idx + 1}</div>
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition flex items-end p-2">
                          <button onClick={openLogin} className="w-full py-2 text-xs rounded bg-white/15 hover:bg-white/25 text-white border border-white/10">Watch</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/* Promotions */}
          <section className={`max-w-[1400px] mx-auto px-4 pb-20 ${contentPad}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                {/* <svg viewBox="0 0 24 24" className="w-5 h-5 text-white/80"><path fill="currentColor" d="M3 5h18v2H3V5Zm0 6h18v2H3v-2Zm0 6h18v2H3v-2Z"/></svg> */}
                <svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon ">
                  <title></title>
                  <path d="M28.651 60.5H11.883c-1.85 0-3.347-1.5-3.347-3.348V37.036c-1.85 0-3.348-1.5-3.348-3.348v-6.722c0-1.85 1.5-3.348 3.348-3.348h20.116V60.5Zm26.813-36.884H35.347V60.5h16.768c1.85 0 3.349-1.5 3.349-3.348V37.036c1.85 0 3.348-1.5 3.348-3.348v-6.722c0-1.85-1.5-3.348-3.348-3.348v-.002ZM45.416 3.5C38.005 3.5 32 9.508 32 16.918h13.418c1.85 0 3.349-1.5 3.349-3.348V6.848c0-1.85-1.5-3.348-3.349-3.348Zm-26.836 0c-1.85 0-3.348 1.5-3.348 3.348v6.722c0 1.85 1.5 3.348 3.348 3.348H32C32 9.506 25.99 3.5 18.58 3.5Z">
                  </path>
                </svg>
                <h2 className="text-xl font-semibold">Promotions</h2>
              </div>
            </div>
            <div className="overflow-x-auto md:overflow-visible no-scrollbar">
              <div className="flex md:grid md:grid-cols-3 gap-4 md:gap-6">
                {[{
                  tag: 'Promo',
                  title: 'NBA - 3rd Quarter Payout',
                  desc: 'Insurance For Bad Beats',
                  cta: 'Read More',
                  image: promoBasketball,
                  tint: 'from-[#1b2a36] to-[#13222b]'
                }, {
                  tag: 'Promo',
                  title: 'Daily Races',
                  desc: "Play in our $100,000 Daily Race",
                  cta: 'Read More',
                  image: promoRocket,
                  tint: 'from-[#1b2a36] to-[#13222b]'
                }, {
                  tag: 'Live Streaming',
                  title: 'NBA Live Streaming',
                  desc: 'Every Match. Every Moment.',
                  cta: 'Read More',
                  image: promoNBA,
                  tint: 'from-[#1b2a36] to-[#13222b]'
                }].map((p, idx) => (
                  <div key={idx} className="shrink-0 w-[280px] sm:w-[320px] md:w-auto rounded-2xl border border-white/10 bg-[#213743] p-4 relative overflow-hidden">
                    <div className="absolute right-4 top-4 w-28 h-28 rounded-lg overflow-hidden">
                      <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="text-[11px] inline-flex px-2 py-0.5 rounded bg-white/10 border border-white/10 text-gray-200">{p.tag}</div>
                    <div className="mt-2 text-lg font-semibold">{p.title}</div>
                    <div className="text-sm text-gray-300">{p.desc}</div>
                    <div className="mt-2 text-sm text-[#00AEEF]">{p.cta}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/* Bets Table */}
          <section className={`max-w-[1400px] mx-auto px-4 pb-24 ${contentPad}`}>
            <div className="flex items-center gap-4 border-b border-white/10 pb-3 mb-4">
              {[
                { key: 'casino', label: 'Casino Bets' },
                { key: 'sports', label: 'Sports Bets' },
                { key: 'race', label: 'Race Leaderboard', dot: true }
              ].map((t) => (
                <button
                  key={t.key}
                  onClick={() => setBetsTab(t.key as any)}
                  className={`relative px-4 py-2 rounded-full text-sm transition ${betsTab === t.key ? 'bg-white/10 text-white' : 'text-gray-300 hover:bg-white/5'}`}
                >
                  {t.label}
                  {t.dot && <span className="absolute -right-1 -top-1 w-2 h-2 rounded-full bg-[#00c853]"></span>}
                </button>
              ))}
            </div>
            {/* Desktop Table */}
            <div className="hidden md:block">
              <div className="grid grid-cols-12 text-xs text-gray-400 px-3 mb-2">
                <div className="col-span-4">Game</div>
                <div className="col-span-2">User</div>
                <div className="col-span-2">Time</div>
                <div className="col-span-2">Bet Amount</div>
                <div className="col-span-1">Multiplier</div>
                <div className="col-span-1 text-right">Payout</div>
              </div>
              <div className="space-y-2">
                {betRows.map((row, idx) => (
                  <div
                    key={idx}
                    className={`grid grid-cols-12 items-center rounded-xl px-3 py-3 border border-white/5 transition ${idx % 2 === 0 ? 'bg-[#172633]' : 'bg-[#0F1C27]'} hover:bg-white/10`}
                  >
                    <div className="col-span-4 flex items-center gap-3">
                      {/* <div className="w-5 h-5 rounded bg-white/10" /> */}
                      <div className="truncate">{row.game}</div>
                    </div>
                    <div className="col-span-2 text-gray-300">{row.user}</div>
                    <div className="col-span-2 text-gray-300">{row.time}</div>
                    <div className="col-span-2 flex items-center gap-2 text-gray-300">
                      <span>{row.amount}</span>
                      <span className="opacity-70">{row.currency}</span>
                    </div>
                    <div className="col-span-1 text-gray-300">{row.multiplier}</div>
                    <div className={`col-span-1 text-right ${row.payoutPositive ? 'text-[#00c853]' : 'text-gray-300'}`}>{row.payout}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* Mobile List */}
            <div className="md:hidden space-y-2">
              {betRows.map((row, idx) => (
                <div
                  key={idx}
                  className={`rounded-xl border border-white/5 p-3 ${idx % 2 === 0 ? 'bg-[#172633]' : 'bg-[#0F1C27]'}`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      {/* <div className="w-5 h-5 rounded bg-white/10" /> */}
                      <div className="text-sm">{row.game}</div>
                    </div>
                    <div className={`text-sm ${row.payoutPositive ? 'text-[#00c853]' : 'text-gray-300'}`}>{row.payout} {row.currency}</div>
                  </div>
                  <div className="grid grid-cols-3 text-xs text-gray-400 gap-2">
                    <div className="truncate">User: {row.user}</div>
                    <div>{row.time}</div>
                    <div className="truncate">Bet: {row.amount} {row.currency}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </main>
        {showLogin && (
          <div className="fixed inset-0 z-[60] flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60" onClick={closeLogin} />
            <div className="relative z-[61] w-[95%] max-w-md mx-auto rounded-xl bg-[#0F1C27] border border-white/10 shadow-2xl">
              <div className="absolute top-1 right-1">
                <button onClick={closeLogin} className="w-8 h-8 rounded hover:bg-white/10 flex items-center justify-center text-white/70" aria-label="Close">
                  <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
                </button>
              </div>
              <LoginPage referalCode={referalCode} />
            </div>
          </div>
        )}
        {showRegister && (
          <div className="fixed inset-0 z-[60] flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60" onClick={closeRegister} />
            <div className="relative z-[61] w-[95%] max-w-md mx-auto rounded-xl bg-[#0F1C27] border border-white/10 shadow-2xl">
              <div className="absolute top-1 right-1">
                <button onClick={closeRegister} className="w-8 h-8 rounded hover:bg-white/10 flex items-center justify-center text-white/70" aria-label="Close">
                  <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>
                </button>
              </div>
              <RegisterPage onSwitchToLogin={() => { closeRegister(); openLogin(); }} />
            </div>
          </div>
        )}
        {/* Customer Support Floating Buttons */}
        {(siteConfig?.contactInfo?.WhatsappSignup || siteConfig?.contactInfo?.WhatsappSupport || siteConfig?.contactInfo?.Instagram || siteConfig?.contactInfo?.TelegramChannel || siteConfig?.contactInfo?.Facebook) && (
          <div className="fixed top-1/2 -translate-y-1/2 right-4 z-40 flex flex-col gap-3" title="Support">
            {/* WhatsApp - Show popup if both exist, otherwise single button */}
            {(siteConfig?.contactInfo?.WhatsappSignup && siteConfig?.contactInfo?.WhatsappSupport) ? (
              <div className="relative" ref={whatsappMenuRef}>
                <button
                  onClick={() => setShowWhatsappMenu(!showWhatsappMenu)}
                  className="w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#20BA5A] border border-white/10 shadow-lg flex items-center justify-center"
                >
                  <FaWhatsapp size={24} className="text-white" />
                </button>
                {showWhatsappMenu && (
                  <div className="absolute right-14 top-1/2 -translate-y-1/2 bg-gradient-to-br from-[#1a1a2e] to-[#16213e] border border-purple-500/50 rounded-lg shadow-xl p-3 min-w-[180px]">
                    <a
                      href={(() => {
                        try {
                          const raw = siteConfig.contactInfo.WhatsappSupport!.trim();
                          return raw.startsWith("http")
                            ? raw
                            : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                        } catch (err) {
                          return "#";
                        }
                      })()}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 px-3 py-2 rounded-md hover:bg-white/10 transition-colors text-white"
                      onClick={(e) => {
                        try {
                          const raw = siteConfig.contactInfo.WhatsappSupport!.trim();
                          const link = raw.startsWith("http")
                            ? raw
                            : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                          if (window.Telegram?.WebApp?.openLink) {
                            e.preventDefault();
                            window.Telegram.WebApp.openLink(link);
                          }
                        } catch (err) {
                          console.warn("WhatsApp link blocked or invalid:", err);
                        }
                        setShowWhatsappMenu(false);
                      }}
                    >
                      <FaWhatsapp size={20} className="text-[#25D366]" />
                      <span className="font-medium">Support</span>
                    </a>
                    <a
                      href={(() => {
                        try {
                          const raw = siteConfig.contactInfo.WhatsappSignup!.trim();
                          return raw.startsWith("http")
                            ? raw
                            : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                        } catch (err) {
                          return "#";
                        }
                      })()}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 px-3 py-2 rounded-md hover:bg-white/10 transition-colors text-white"
                      onClick={(e) => {
                        try {
                          const raw = siteConfig.contactInfo.WhatsappSignup!.trim();
                          const link = raw.startsWith("http")
                            ? raw
                            : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                          if (window.Telegram?.WebApp?.openLink) {
                            e.preventDefault();
                            window.Telegram.WebApp.openLink(link);
                          }
                        } catch (err) {
                          console.warn("WhatsApp link blocked or invalid:", err);
                        }
                        setShowWhatsappMenu(false);
                      }}
                    >
                      <FaWhatsapp size={20} className="text-[#25D366]" />
                      <span className="font-medium">Get Your ID</span>
                    </a>
                  </div>
                )}
              </div>
            ) : siteConfig?.contactInfo?.WhatsappSignup ? (
              <a 
                href={(() => {
                  try {
                    const raw = siteConfig.contactInfo.WhatsappSignup.trim();
                    return raw.startsWith("http")
                      ? raw
                      : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                  } catch (err) {
                    console.warn("WhatsApp link invalid:", err);
                    return "#";
                  }
                })()}
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#20BA5A] border border-white/10 shadow-lg flex items-center justify-center"
                onClick={(e) => {
                  try {
                    const raw = siteConfig.contactInfo.WhatsappSignup.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      e.preventDefault();
                      window.Telegram.WebApp.openLink(link);
                    }
                  } catch (err) {
                    console.warn("WhatsApp link blocked or invalid:", err);
                  }
                }}
              >
                <FaWhatsapp size={24} className="text-white" />
              </a>
            ) : siteConfig?.contactInfo?.WhatsappSupport ? (
              <a 
                href={(() => {
                  try {
                    const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                    return raw.startsWith("http")
                      ? raw
                      : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                  } catch (err) {
                    console.warn("WhatsApp link invalid:", err);
                    return "#";
                  }
                })()}
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 rounded-full bg-[#25D366] hover:bg-[#20BA5A] border border-white/10 shadow-lg flex items-center justify-center"
                onClick={(e) => {
                  try {
                    const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      e.preventDefault();
                      window.Telegram.WebApp.openLink(link);
                    }
                  } catch (err) {
                    console.warn("WhatsApp link blocked or invalid:", err);
                  }
                }}
              >
                <FaWhatsapp size={24} className="text-white" />
              </a>
            ) : null}
            {siteConfig?.contactInfo?.Instagram && (
              <a 
                href={(() => {
                  try {
                    const raw = siteConfig.contactInfo.Instagram.trim();
                    return raw.startsWith("http")
                      ? raw
                      : `https://instagram.com/${raw}`;
                  } catch (err) {
                    console.warn("Instagram link invalid:", err);
                    return "#";
                  }
                })()}
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 rounded-full bg-[#C13584] hover:bg-[#AD2E77] border border-white/10 shadow-lg flex items-center justify-center"
                onClick={(e) => {
                  try {
                    const raw = siteConfig.contactInfo.Instagram.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://instagram.com/${raw}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      e.preventDefault();
                      window.Telegram.WebApp.openLink(link);
                    }
                  } catch (err) {
                    console.warn("Instagram link blocked or invalid:", err);
                  }
                }}
              >
                <FaInstagram size={24} className="text-white" />
              </a>
            )}
            {siteConfig?.contactInfo?.TelegramChannel && (
              <a 
                href={(() => {
                  try {
                    const tg = siteConfig.contactInfo.TelegramChannel.trim();
                    let link = tg;
                    if (!tg.startsWith('t.me') && !tg.startsWith('http')) {
                      link = `t.me/${tg}`;
                    }
                    return link.startsWith('http') ? link : `//${link}`;
                  } catch (err) {
                    console.warn("Telegram link invalid:", err);
                    return "#";
                  }
                })()}
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 rounded-full bg-[#0088cc] hover:bg-[#0077b5] border border-white/10 shadow-lg flex items-center justify-center"
                onClick={(e) => {
                  try {
                    const tg = siteConfig.contactInfo.TelegramChannel.trim();
                    let link = tg;
                    if (!tg.startsWith('t.me') && !tg.startsWith('http')) {
                      link = `t.me/${tg}`;
                    }
                    const finalLink = link.startsWith('http') ? link : `//${link}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      e.preventDefault();
                      window.Telegram.WebApp.openLink(finalLink.startsWith('//') ? `https:${finalLink}` : finalLink);
                    } else {
                      window.open(finalLink, '_blank');
                    }
                  } catch (err) {
                    console.warn("Telegram link blocked or invalid:", err);
                  }
                }}
              >
                <FaTelegramPlane size={24} className="text-white" />
              </a>
            )}
            {siteConfig?.contactInfo?.Facebook && (
              <a 
                href={(() => {
                  try {
                    const raw = siteConfig.contactInfo.Facebook.trim();
                    return raw.startsWith("http")
                      ? raw
                      : `https://facebook.com/${raw}`;
                  } catch (err) {
                    console.warn("Facebook link invalid:", err);
                    return "#";
                  }
                })()}
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-12 h-12 rounded-full bg-[#1877F2] hover:bg-[#1565C0] border border-white/10 shadow-lg flex items-center justify-center"
                onClick={(e) => {
                  try {
                    const raw = siteConfig.contactInfo.Facebook.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://facebook.com/${raw}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      e.preventDefault();
                      window.Telegram.WebApp.openLink(link);
                    }
                  } catch (err) {
                    console.warn("Facebook link blocked or invalid:", err);
                  }
                }}
              >
                <FaFacebook size={24} className="text-white" />
              </a>
            )}
          </div>
        )}
        {/* Mobile Bottom Nav */}
        <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#0F1C27]/95 border-t border-white/10 md:hidden">
          <div className="max-w-[1400px] mx-auto px-2 py-2 grid grid-cols-5 text-[10px] text-gray-300">
            {[
              { label: 'Browse', icon: (<svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M10 3H3v7h7V3Zm11 0h-7v7h7V3ZM10 14H3v7h7v-7Zm11 0h-7v7h7v-7Z" /></svg>) },
              { label: 'Casino', icon: (<svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M12 2 2 7l10 5 10-5-10-5Zm0 7L2 4v13l10 5 10-5V4l-10 5Z" /></svg>) },
              { label: 'Bets', icon: (<svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M21 7H3V5h18v2Zm0 4H3v2h18v-2Zm0 6H3v2h18v-2Z" /></svg>) },
              { label: 'Sports', icon: (<svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" /></svg>) },
              { label: 'Chat', icon: (<svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="currentColor" d="M2 4h20v10H6l-4 4V4Z" /></svg>) }
            ].map((item, idx) => (
              <div key={idx} className="flex flex-col items-center cursor-pointer" onClick={openLogin}>
                {item.icon}
                <span className="mt-1">{item.label}</span>
              </div>
            ))}
          </div>
        </nav>
        {/* Desktop Footer */}
        <footer className="border-t border-white/5 hidden md:block">
          <div className={`max-w-[1400px] mx-auto px-4 py-10 grid grid-cols-6 gap-6 text-sm text-gray-300 ${contentPad}`}>
            <div>
              <div className="text-white font-semibold mb-3">Casino</div>
              <div className="space-y-2">
                <div>Casino Games</div>
                <div>Slots</div>
                <div>Live Casino</div>
                <div>Roulette</div>
                <div>Blackjack</div>
                <div>Poker</div>
                <div>Providers</div>
                <div>Promos&Competitions</div>
              </div>
            </div>
            <div>
              <div className="text-white font-semibold mb-3">Sports</div>
              <div className="space-y-2">
                <div>Sportsbook</div>
                <div>Live Sports</div>
                <div>Soccer</div>
                <div>Basketball</div>
                <div>Tennis</div>
                <div>eSports</div>
                <div>Bet Bonuses</div>
                <div>Sports Rules</div>
                <div>Racing Rules</div>
              </div>
            </div>
            <div>
              <div className="text-white font-semibold mb-3">Support</div>
              <div className="space-y-2">
                <div className="flex items-center gap-1">
                  Help Center
                  <svg viewBox="0 0 24 24" className="w-3 h-3">
                    <path fill="currentColor" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
                  </svg>
                </div>
                <div>Fairness</div>
                <div className="flex items-center gap-1">
                  Gambling Helpline
                  <svg viewBox="0 0 24 24" className="w-3 h-3">
                    <path fill="currentColor" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
                  </svg>
                </div>
                <div>Live Support</div>
                <div>Self Exclusion</div>
              </div>
            </div>
            <div>
              <div className="text-white font-semibold mb-3">About Us</div>
              <div className="space-y-2">
                <div>VIP Club</div>
                <div>Affiliate</div>
                <div>Privacy Policy</div>
                <div>AML Policy</div>
                <div>Terms of Service</div>
              </div>
            </div>
            <div>
              <div className="text-white font-semibold mb-3">Payment Info</div>
              <div className="space-y-2">
                <div>Deposit&Withdrawals</div>
                <div>Currency Guide</div>
                <div>Crypto Guide</div>
                <div>Supported Crypto</div>
                <div>How to Use the Vault</div>
                <div>How Much to Bet With</div>
              </div>
            </div>
            <div>
              <div className="text-white font-semibold mb-3">How-to Guides</div>
              <div className="space-y-2">
                <div>How-to Guides</div>
                <div>Online Casino Guide</div>
                <div>Sports Betting Guide</div>
                <div>How to Live Stream Sports</div>
                <div>Strike VIP Guide</div>
                <div>House Edge Guide</div>
              </div>
            </div>
          </div>
          <div className="border-t border-white/5">
            <div className={`max-w-[1400px] mx-auto px-4 py-6 flex items-center justify-between text-xs text-gray-400 xl:pl-[260px] ${contentPad}`}>
              <div>© 2025 {BrandName} | All rights reserved</div>
              {/* <div className="flex gap-2">
                <div className="h-6 w-10 rounded bg-white/10" />
                <div className="h-6 w-10 rounded bg-white/10" />
                <div className="h-6 w-10 rounded bg-white/10" />
              </div> */}
            </div>
          </div>
        </footer>

        {/* Mobile Footer Accordion */}
        <footer className="border-t pb-12 border-white/5 md:hidden">
          <div className="px-4 py-6 space-y-4">
            {[
              {
                title: 'Casino',
                links: ['Casino Games', 'Slots', 'Live Casino', 'Roulette', 'Blackjack', 'Poker', 'Providers', 'Promos&Competitions']
              },
              {
                title: 'Sports',
                links: ['Sportsbook', 'Live Sports', 'Soccer', 'Basketball', 'Tennis', 'eSports', 'Bet Bonuses', 'Sports Rules', 'Racing Rules']
              },
              {
                title: 'Support',
                links: ['Help Center', 'Fairness', 'Gambling Helpline', 'Live Support', 'Self Exclusion']
              },
              {
                title: 'About Us',
                links: ['VIP Club', 'Affiliate', 'Privacy Policy', 'AML Policy', 'Terms of Service']
              },
              {
                title: 'Payment Info',
                links: ['Deposit&Withdrawals', 'Currency Guide', 'Crypto Guide', 'Supported Crypto', 'How to Use the Vault', 'How Much to Bet With']
              },
              {
                title: 'How-to Guides',
                links: ['How-to Guides', 'Online Casino Guide', 'Sports Betting Guide', 'How to Live Stream Sports', 'Strike VIP Guide', 'House Edge Guide']
              }
            ].map((section, index) => (
              <div key={index} className="border-b border-white/5 pb-4">
                <button
                  className="w-full flex items-center justify-between text-white font-semibold text-sm py-2"
                  onClick={() => {
                    const content = document.getElementById(`mobile-footer-${index}`);
                    if (content) {
                      content.style.display = content.style.display === 'none' ? 'block' : 'none';
                    }
                  }}
                >
                  {section.title}
                  <svg viewBox="0 0 24 24" className="w-4 h-4 transition-transform">
                    <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                  </svg>
                </button>
                <div id={`mobile-footer-${index}`} className="hidden space-y-2 mt-2 text-sm text-gray-300">
                  {section.links.map((link, linkIndex) => (
                    <div key={linkIndex} className="py-1">{link}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="border-t border-white/5 px-4 py-4">
            <div className="text-xs text-gray-400 text-center">
              © 2025 {BrandName} | All rights reserved
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    siteConfig: state.userDetails?.siteConfig,
  };
};

export default connect(mapStateToProps)(LandingPage);
